import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { initHotjar } from './lib/hotjar';

// Registrar Service Worker
if ('serviceWorker' in navigator) {
  console.log('Registrando Service Worker...');
  
  navigator.serviceWorker.register('/sw.js?v=1.0.15', {
    scope: '/'
  })
  .then(registration => {
    console.log('✅ SW registrado com sucesso:', registration);
    console.log('Scope:', registration.scope);
    
    // Verificar se está ativo
    if (registration.active) {
      console.log('✅ SW já está ativo');
    } else {
      console.log('⏳ SW ainda não está ativo');
    }
  })
  .catch(error => {
    console.error('❌ SW falhou no registro:', error);
  });
  
  // Listener para mudanças no SW
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('🔄 SW controller mudou');
  });
} else {
  console.log('❌ Service Worker não suportado');
}

// Inicializar Hotjar/Contentsquare]
initHotjar({
  hotjarId: process.env.REACT_APP_HOTJAR_ID || 'PLACEHOLDER',
  enabled: process.env.REACT_APP_HOTJAR_ENABLED
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <PermissionsProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </PermissionsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
